import CallInitiatedSuccess from './component';

export const component = CallInitiatedSuccess;
export default CallInitiatedSuccess;
